export const getFileExtension = (url: string) => {
  const pathname = url.split('?')[0]

  return pathname.split('.').pop()
}
